module.exports = __webpack_public_path__ + "assets/img/teacher (32).6dd1d776.png";